import { useEffect, useState } from "react";
import { Button, Popup } from "antd-mobile";
import { TiAffix, TiForm } from "@ti/ui-mobile";
import { useToggle } from "ahooks";
import dayjs from "dayjs";
import { useEnums } from "@/utils/enumsUtils";
import { getApprovalOrApplyList } from "@/services/transfer";
import { SpaceBetweenBox } from "@/pages/transfer/components/styles";
import { useT } from "@/utils/intlUtils";
import searchImage from "@/assets/transfer/menu2x.png";

type SearchProps = {
  onSearch?: (value: FilerDataType) => void;
  value?: FilerDataType;
};

export type FilerDataType = {
  type?: "1" | "2" | "4";
  sourceCompanyId?: string;
  dateRangePicker?: Date[];
  startTime?: string;
  endTime?: string;
};

const now = new Date();

export default (props: SearchProps) => {
  const { onSearch, value } = props;

  const t = useT();
  const [form] = TiForm.useForm<FilerDataType>();

  const [visible, { setLeft, setRight }] = useToggle(false);

  const { materialApplyType, transferStatus } = useEnums([
    { code: "materialApplyType", isAll: true },
    { code: "transferStatus", isAll: true },
  ]);

  const [companyList, setCompanyList] = useState([]);

  useEffect(() => {
    if (value && visible) {
      const params = {
        ...value,
      };
      if (value?.startTime && value?.endTime) {
        params.dateRangePicker = [
          new Date(value?.startTime),
          new Date(value?.endTime),
        ];
      }
      form.setFieldsValue(params);
    }
  }, [form, value, visible]);

  useEffect(() => {
    getApprovalOrApplyList({
      page: 1,
      queryType: 1,
      size: 10000,
    }).then((res) => {
      const list = res?.model?.result?.map((item: any) => {
        return {
          label: item.companyName,
          value: item.companyId,
        };
      });
      list?.unshift({
        label: t("全部"),
        value: "",
      });
      setCompanyList(list);
    });
  }, []);

  const onFinish = () => {
    const searchParams = form.getFieldsValue();
    const params = {
      ...searchParams,
    };
    if (searchParams.dateRangePicker) {
      params.startTime = dayjs(searchParams.dateRangePicker[0]).format(
        "YYYY-MM-DD 00:00:00",
      );

      params.endTime = dayjs(searchParams.dateRangePicker[1]).format(
        "YYYY-MM-DD 23:59:59",
      );
      delete params.dateRangePicker;
    } else {
      params.startTime = "";
      params.endTime = "";
    }
    onSearch?.(params);
    setLeft();
  };
  const onReset = () => {
    form.resetFields();
  };
  return (
    <>
      <img
        style={{ width: "24px", height: "24px", marginLeft: 10 }}
        src={searchImage}
        onClick={setRight}
      />
      <Popup
        visible={visible}
        onMaskClick={() => {
          setLeft();
        }}
        destroyOnClose={true}
        position="right"
        bodyStyle={{
          width: "80vw",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <TiAffix offsetTop={0}>
          <h3
            style={{
              textAlign: "center",
              borderBottom: "1px solid #eee",
              paddingBottom: 15,
              paddingTop: 0,
            }}
          >
            {t("筛选")}
          </h3>
        </TiAffix>
        <div style={{ flex: 1, overflow: "auto" }}>
          <TiForm form={form}>
            <TiForm.DateRangePicker
              name="dateRangePicker"
              label={t("创建时间")}
              fieldProps={{
                precision: "day",
                max: dayjs().toDate(),
              }}
            />
            <TiForm.Selector
              name="type"
              label={t("调拨类型")}
              fieldProps={{
                columns: 2,
              }}
              valueEnum={materialApplyType}
            />

            <TiForm.Selector
              name="sourceCompanyId"
              label={t("审批企业")}
              fieldProps={{
                columns: 1,
                options: companyList,
              }}
            />
            <TiForm.Selector
              name="transferStatus"
              label={t("调拨状态")}
              fieldProps={{
                columns: 2,
              }}
              valueEnum={transferStatus}
            />
          </TiForm>
        </div>
        <TiAffix offsetBottom={0}>
          <SpaceBetweenBox style={{ padding: 20 }}>
            <Button block onClick={onReset}>
              {t("重置")}
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              block
              color="primary"
              onClick={onFinish}
            >
              {t("确认")}
            </Button>
          </SpaceBetweenBox>
        </TiAffix>
      </Popup>
    </>
  );
};
